<template>
    <div class="bcgl">
        <div style="margin: 0rem 0 0 0rem; border: 1px #DDDDDD solid;">
            <el-card class="box-card">
                <div slot="header">
                    <el-row style="margin-bottom: 20px">
                        <el-col :span="24">
                            <div style="line-height: 3rem; font-size: 1.5rem;">客户合同详情</div>
                        </el-col>
                    </el-row>
                </div>
               <el-row style="text-align: left">
                   <el-col :span="8">
                       <el-card class="box-card">
                           <div slot="header" >
                               <span>合同详情</span>
                           </div>
                           <div class="text item">
                               <span style="font-weight: bold">客户单位：</span>{{contractInfo.customerName}}
                           </div>
                           <div class="text item">
                               <span style="font-weight: bold">服务地点：</span>{{contractInfo.workPlace}}
                           </div>
                           <div class="text item">
                               <span style="font-weight: bold">状态：</span>
                               <el-tag v-if="contractInfo.status === 0" type="success">未过期</el-tag>
                               <el-tag v-else type="danger">已过期</el-tag>
                           </div>
                           <div class="text item">
                               <span style="font-weight: bold">开始日期：</span>{{contractInfo.startTime?contractInfo.startTime.substr(0,10):''}}
                           </div>
                           <div class="text item">
                               <span style="font-weight: bold">结束日期：</span>{{contractInfo.endTime?contractInfo.endTime.substr(0,10):''}}
                           </div>
                           <div class="text item">
                               <span style="font-weight: bold">合同金额(元)：</span>{{toThousands(contractInfo.amount)}}
                           </div>
                           <!-- <div class="text item">
                               <span style="font-weight: bold">已收金额(元)：</span>{{toThousands(contractInfo.receiveAmount)}}
                           </div> -->
                           <!-- <div class="text item">
                               <span style="font-weight: bold">其他金额(元)：</span>{{toThousands(contractInfo.otherAmount)}}
                           </div> -->
                           <div class="text item">
                               <span style="font-weight: bold">合同文本类型：</span>{{contractInfo.htwblx}}
                           </div>
                           <div class="text item">
                               <span style="font-weight: bold">岗点数：</span>{{contractInfo.gdNumber}}
                           </div>
                           <div class="text item">
                               <span style="font-weight: bold">总计分配人数：</span>{{contractInfo.fprsNumber}}
                           </div>
                           <div class="text item" style="border-bottom: 1px solid #000;">
                               <span style="font-weight: bold">备注：</span>{{contractInfo.remaek}}
                           </div>
                           <div class="text item">
                               <span style="font-weight: bold">人员配置：</span>
                           </div>
                           <el-table :data="workerConfig"  border style="width: 100%">

                               <el-table-column   label="类型" prop="type" width="100">
                               </el-table-column>
                               <el-table-column label="人数" prop="num" width="100">
                               </el-table-column>
                               <el-table-column label="单价(元/人)" prop="price" width="100">
                                   <template slot-scope="scope">
                                       {{toThousands(scope.row.price)}}
                                   </template>
                               </el-table-column>
                               <el-table-column label="开始日期" prop="startDate" width="150">
                               </el-table-column>
                               <el-table-column label="截止日期" prop="endDate" width="150">
                               </el-table-column>
                           </el-table>
                           <div class="text item" style="margin-top: 20px;">
                               <span style="font-weight: bold">已收金额：</span>
                           </div>
                           <el-table :data="receiveAmount"  border style="width: 100%">
                                <el-table-column label="期初余额金额(元)" prop="qcyeje">
                                    <template slot-scope="scope">
                                        {{ scope.row.qcyeje }}
                                        <!-- {{toThousands(scope.row.qcyeje)}} -->
                                    </template>
                                </el-table-column>
                                <el-table-column label="本期开票金额(元)" prop="bqkpje">
                                    <template slot-scope="scope">
                                        {{ scope.row.bqkpje }}
                                        <!-- {{toThousands(scope.row.bqkpje)}} -->
                                    </template>
                                </el-table-column>
                                <el-table-column label="本期收款金额(元)" prop="bqskje">
                                    <template slot-scope="scope">
                                        {{ scope.row.bqskje }}
                                        <!-- {{toThousands(scope.row.bqskje)}} -->
                                    </template>
                                </el-table-column>
                                <el-table-column label="期末欠款金额(元)" prop="qmqkje">
                                    <template slot-scope="scope">
                                        {{ scope.row.qmqkje }}
                                        <!-- {{toThousands(scope.row.qmqkje)}} -->
                                    </template>
                                </el-table-column>
                               <el-table-column label="收款日期" prop="skrq" width="150">
                               </el-table-column>
                           </el-table>
                           <div class="text item" style="margin-top: 20px;">
                               <span style="font-weight: bold">其他金额：</span>
                           </div>
                           <el-table :data="qtjeData"  border style="width: 100%">
                                <el-table-column label="金额(元)" prop="je">
                                    <template slot-scope="scope">
                                        {{ scope.row.je }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="日期" prop="rq">
                                </el-table-column>
                                <el-table-column label="备注" prop="bz">
                                </el-table-column>
                            </el-table>
                       </el-card>
                   </el-col>
                   <el-col :span="8">
                       <el-card class="box-card">
                       <div slot="header" >
                           <span>岗点信息</span>
                       </div>
                           <el-table
                                   highlight-current-row
                                   :data="gdList"
                                   border
                                   v-loading="gdLoading"
                                   @current-change="handleCurrentChange"
                                   style="width: 100%;">
                               <el-table-column label="名称" prop="gdmc">
                               </el-table-column>
                               <el-table-column prop="morrs" label="早班人数" width="50">
                               </el-table-column>
                               <el-table-column  prop="aftrs" label="中班人数" width="50">
                               </el-table-column>
                               <el-table-column  prop="evers" label="晚班人数" width="50">
                               </el-table-column>
                               <el-table-column  prop="fprs" label="分配人数" width="50">
                               </el-table-column>
                           </el-table>
                           <el-pagination
                                   @current-change="currentChangeHandle"
                                   :current-page="gdpageIndex"
                                   :page-size="gdpageSize"
                                   :total="gdtotalPage"
                                   layout="total, prev, pager, next">
                           </el-pagination>
                   </el-card>
                   </el-col>
                   <el-col :span="8">
                       <el-card class="box-card">
                           <div slot="header" >
                               <span>人员信息</span>
                           </div>
                           <el-table
                                   :data="userList"
                                   v-loading="userLoading"
                                   @row-click="showUserDetail"
                                   border
                                   style="width: 100%;">
                               <el-table-column label="姓名" prop="xm">
                               </el-table-column>
                               <el-table-column prop="zzdyqc" label="部门" >
                               </el-table-column>
                               <el-table-column  prop="sjhm" label="手机号">
                               </el-table-column>
                           </el-table>
                           <el-pagination
                                   @current-change="currentChangeHandle2"
                                   :current-page="userpageIndex"
                                   :page-size="userpageSize"
                                   :total="usertotalPage"
                                   layout="total, prev, pager, next">
                           </el-pagination>
                       </el-card>
                   </el-col>
               </el-row>
                <user-detail ref="userDetail" v-if="userDetailVisiable"></user-detail>
            </el-card>
        </div>
    </div>
</template>
<script>
    import {
        Vue,
        Component
    } from 'vue-property-decorator'
    import UserDetail from './user-detail'
    @Component({
        name: 'contractdetail',
        components:{
            UserDetail
        }
    })

    export default class contractdetail extends Vue {
        contractInfo=''
        contractId=''
        workerConfig=[]
        receiveAmount=[]
        qtjeData=[]
        gdList=[]
        gdpageIndex=1
        gdpageSize=8
        gdtotalPage=0
        userList=[]
        userpageIndex=1
        userpageSize=8
        usertotalPage=0
        gdid=''
        gdLoading=false
        userLoading=false
        userDetailVisiable=false
        created() {
            this.contractId = this.$route.query.id
            this.getcontractInfo();
            this.getWorkConfig();
            this.getReceiveAmount();
            this.getQtjeData();
            this.getGdLsit();
        }
        getcontractInfo() {
            this.$request({
                url: `/bjba/contract/findInfoById/${this.contractId}`,
                method: 'get'
            })
                .then(response => {
                    this.loading = false;
                    console.log(response);
                    let data = response.data;
                    if (data.code == 200) {
                        this.contractInfo = data.data
                    } else {
                        this.$message.error(data.message)
                    }
                })
                .catch(error => {
                    console.log(error)
                    this.$message.error(error)
                });
        }
        toThousands(num) {
            var result = [ ], counter = 0;
            num = (num || 0).toString().split('');
            for (var i = num.length - 1; i >= 0; i--) {
                counter++;
                result.unshift(num[i]);
                if (!(counter % 3) && i != 0) { result.unshift(','); }
            }
            return result.join('');
        }
        getWorkConfig() {
            this.$http({
                url: `/bjba/contract/findConfigByContarctId/${this.contractId}`,
                method: 'get'
            }).then(({data}) => {
                this.workerConfig = data.data;
            })
        }
        getReceiveAmount(){
            this.$http({
                url: `/bjba/contract/findReceiveAmountByContarctId/${this.contractId}`,
                method: 'get'
            }).then(({data}) => {
                this.receiveAmount = data.data;
            })
        }
        getQtjeData(){
            this.$http({
                url: '/bjba/contract/findQtjeByContarctId/'+this.contractId,
                method: 'get'
            }).then(({data}) => {
                this.qtjeData = data.data;
            })
        }
        getGdLsit() {
            this.$request({
				url: `/bjba/contract/findCustomerIds/`+this.contractId,
				method: 'get'
			}).then(response => {
				console.log("查询客户id信息：",response);
				if (response.data.code == 200) {
					this.getGdxxList(response.data.data)
				}
			}).catch(error => {
				console.log(error)
			});
        }
        getGdxxList(customerIds) {
            this.gdLoading =true
            this.$request({
                url: '/bjba/contract/gdxxList',
                method: 'get',
                params: {
                    'page': this.gdpageIndex,
                    'pagesize': this.gdpageSize,
                    'id': customerIds.replace(/\,/g, "','")
                }
            }).then(response => {
                this.gdLoading =false
                console.log('aaaaaaaaaaaaaa'+response)
                this.gdList = response.data.data.content;
                this.gdtotalPage = response.data.data.totalElements;
            }).catch(error => {
                this.gdLoading =false
                console.log(error)
            });
        }
        getUserList() {
            this.userLoading = true
            this.$request({
                url: '/bjba/map/userList',
                method: 'get',
                params: {
                    'page': this.userpageIndex,
                    'pageSize': this.userpageSize,
                    'id': this.gdid
                }
            }).then(response => {
                this.userLoading = false
                console.log('aaaaaaaaaaaaaa'+response)
                this.userList = response.data.data.list;
                this.usertotalPage = response.data.data.total;
            }).catch(error => {
                this.userLoading = false
                console.log(error)
            });
        }
        currentChangeHandle (val) {
            this.gdpageIndex = val
            this.getGdLsit()
        }
        currentChangeHandle2 (val) {
            this.userpageIndex = val
            this.getUserList()
        }
        handleCurrentChange(val) {
           if(val) {
               this.gdid = val.gdid
               this.getUserList()
           }
        }
        showUserDetail(row) {
            this.userDetailVisiable = true
            this.$nextTick(() =>{
                this.$refs.userDetail.init(row.id)
            })
        }
    }
</script>
<style lang="scss" scoped>
    .bcgl {}
    .text {
        text-align: left;
        font-size: 14px;
        padding: 3px 0;
    }
     .item {
         margin-bottom: 18px;
     }
</style>
